export default {
  data() {
    return {
      mixin_bulk_message_status: {}, // empty object avoids a bunch of null errors in row component bindings
    };
  },

  computed: {
    mixin_send_complete() {
      switch (this.mixin_bulk_message_status?.state) {
        case 'edit':
          return false;
        case 'send':
          return false;
        case 'paused':
          return false;
        case 'finished':
          return true;
        case 'cancelled':
          return true;
      }

      return false;
    },

    mixin_status_description() {
      switch (this.mixin_bulk_message_status?.state) {
        case 'edit': {
          if (
            this.mixin_bulk_message_status.scheduled_send_time &&
            this.mixin_bulk_message_status.scheduled_send_time > 0
          ) {
            const date = this.$rc.pretty(
              this.mixin_bulk_message_status.scheduled_send_time,
              'date'
            );
            const time = this.$rc.pretty(
              this.mixin_bulk_message_status.scheduled_send_time,
              'time'
            );
            const employee = this.mixin_bulk_message_status.scheduled_by_employee_label;
            return `Scheduled to be sent on ${date} at ${time} by ${employee}`;
          }

          return 'Not Yet Sent';
        }
        case 'send':
          return 'Sending';
        case 'paused':
          return 'Paused';
        case 'finished':
          return 'Finished Sending';
        case 'cancelled':
          return 'Cancelled';
      }

      return 'Unknown';
    },

    mixin_failed_total() {
      if (!this.mixin_bulk_message_status) return 0;

      return (
        this.mixin_bulk_message_status.count_failed_other +
        this.mixin_bulk_message_status.count_failed_unable_to_generate_message
      );
    },

    mixin_filtered_total() {
      if (!this.mixin_bulk_message_status) return 0;

      return (
        this.mixin_bulk_message_status.count_filtered_duplicate +
        this.mixin_bulk_message_status.count_filtered_previously_opted_out +
        this.mixin_bulk_message_status.count_filtered_consent +
        this.mixin_bulk_message_status.count_filtered_simple_do_not_send_after_wall_time +
        this.mixin_bulk_message_status.count_filtered_send_time_restrictions +
        this.mixin_bulk_message_status.count_filtered_days_since_last_bulk_message +
        this.mixin_bulk_message_status.count_filtered_received_bulk_message +
        this.mixin_bulk_message_status.count_filtered_order_history +
        this.mixin_bulk_message_status.count_filtered_tcpa_litigators_list +
        this.mixin_bulk_message_status.count_filtered_texas_do_not_call_list +
        this.mixin_bulk_message_status.count_filtered_recipient_in_locations +
        this.mixin_bulk_message_status.count_filtered_other
      );
    },

    mixin_not_sent_total() {
      if (!this.mixin_bulk_message_status) return 0;

      return (
        this.mixin_bulk_message_status.count_cancelled +
        this.mixin_failed_total +
        this.mixin_filtered_total
      );
    },

    mixin_recipients_total() {
      if (!this.mixin_bulk_message_status) return 0;

      return (
        this.mixin_bulk_message_status.count_pending +
        this.mixin_bulk_message_status.count_sent +
        this.mixin_not_sent_total
      );
    },

    mixin_time_elapsed() {
      let time_start =
        this.mixin_bulk_message_status.sent_time == null
          ? this.current_time
          : this.mixin_bulk_message_status.sent_time;

      let delta = this.current_time - time_start;
      let total_seconds = Math.floor(delta / 1000);

      let hours = Math.floor(total_seconds / 3600);
      let minutes = Math.floor((total_seconds % 3600) / 60);
      let seconds = total_seconds % 60;

      let parts = [];

      if (hours > 0) {
        parts.push(`${hours}h`);
      }

      if (minutes > 0) {
        parts.push(`${minutes}m`);
      }

      if (seconds > 0 || parts.length === 0) {
        parts.push(`${seconds}s`);
      }

      return parts.join(' ');
    },

    mixin_time_total() {
      let total_seconds = this.mixin_recipients_total * 2;

      let hours = Math.floor(total_seconds / 3600);
      let minutes = Math.floor((total_seconds % 3600) / 60);
      let seconds = total_seconds % 60;

      let parts = [];

      if (hours > 0) {
        parts.push(`${hours}h`);
      }

      if (minutes > 0) {
        parts.push(`${minutes}m`);
      }

      if (seconds > 0 || parts.length === 0) {
        parts.push(`${seconds}s`);
      }

      return parts.join(' ');
    },

    mixin_status_string() {
      if (this.mixin_bulk_message_status.state == 'finished') return 'Complete';

      return 'Sending';
    },

    mixin_percent_total() {
      if (this.mixin_recipients_total === 0) return 0;
      if (this.mixin_bulk_message_status.count_pending == null) return 0;

      let percent =
        (this.mixin_recipients_total - this.mixin_bulk_message_status.count_pending) /
        this.mixin_recipients_total;
      return Math.floor(100 * percent);
    },

    mixin_messages_processed() {
      return (
        (this.mixin_bulk_message_status.count_sent || 0) +
        (this.mixin_failed_total || 0) +
        (this.mixin_filtered_total || 0)
      );
    },

    mixin_filter_rate_percent() {
      if (this.mixin_messages_processed === 0) return 0;
      return Math.round(((this.mixin_filtered_total || 0) / this.mixin_messages_processed) * 100);
    },
  },

  methods: {
    mixinGetSendStatusDetail(bulk_message_id, success_cb) {
      this.$rc.rest({
        spinner: false,
        endpoint: 'GET-PROFILE: /api/v1/bulk/messages/send-status-detail/:bulk_message_id',

        params: {
          bulk_message_id,
        },

        on_success: data => {
          this.mixin_bulk_message_status = data.bulk_message_status;
          if (success_cb && typeof success_cb === 'function') {
            success_cb(data.bulk_message_status);
          }
        },

        // Only alert on initial page load
        on_error: this.mixin_bulk_message_status?.bulk_message_id
          ? null
          : 'Unable to get bulk message status',
      });
    },
  },
};
